(() => {
  const GLS_WIDGET_SRC = 'https://map.gls-slovenia.com/widget/gls-dpm.js';

  const ensureGlsWidgetScript = () => {
    if (window.customElements?.get?.('gls-dpm-dialog')) return;
    if (document.querySelector('script[data-spzdbl-gls-widget="true"]')) return;

    const script = document.createElement('script');
    script.type = 'module';
    script.src = GLS_WIDGET_SRC;
    script.dataset.spzdblGlsWidget = 'true';
    document.head.appendChild(script);
  };

  const getModalForOpener = (opener) => {
    const summary = opener?.closest('.cart-drawer__summary') || opener?.closest('.cart__ctas')?.parentElement;
    const localModal = summary?.querySelector('[data-gls-delivery-modal]');

    return localModal || document.querySelector('[data-gls-delivery-modal]');
  };

  const selectedOption = (modal) => modal?.querySelector('input[name="gls_delivery_option"]:checked');
  const errorBox = (modal) => modal?.querySelector('[data-gls-delivery-error]');

  const enableSubmit = (modal) => {
    modal?.querySelector('[data-gls-delivery-submit]')?.removeAttribute('disabled');
  };

  const showError = (modal, message) => {
    const error = errorBox(modal);
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
  };

  const clearError = (modal) => {
    const error = errorBox(modal);
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  };

  // Plačilo po povzetju je izklopljeno (cdx_gls_cod_on = false): vrstici ostaneta v izbiri, izbira
  // pa odpre obvestilo namesto nadaljevanja; izbrana ostane prejšnja možnost.
  // Obvestilo se ob prikazu prestavi na vrh strani (v predalu košarice v njegov dialog), da je nad
  // glavo, thumb menijem in spodnjo vrstico; ob zaprtju gre nazaj v svojo izbiro dostave.
  const codOffHome = new WeakMap();
  const openCodOffNotice = () => document.querySelector('[data-gls-cod-off-notice]:not([hidden])');

  const showCodOffNotice = (modal) => {
    const notice = modal?.querySelector('[data-gls-cod-off-notice]');
    if (!notice) return;
    codOffHome.set(notice, modal);
    (modal.closest('dialog') || document.body).appendChild(notice);
    notice.hidden = false;
    notice.querySelector('[data-gls-cod-off-close]')?.focus({ preventScroll: true });
  };

  const hideCodOffNotice = (notice) => {
    if (!notice) return;
    notice.hidden = true;
    const modal = codOffHome.get(notice);
    if (modal?.isConnected) modal.appendChild(notice);
    else notice.remove();
  };

  const lastValidOption = new WeakMap();

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[character]);

  const openModal = (modal) => {
    if (!modal) return;
    clearError(modal);
    hideCodOffNotice(openCodOffNotice());
    enableSubmit(modal);
    modal.hidden = false;
    requestAnimationFrame(() => {
      modal.scrollIntoView({ block: 'nearest' });
      modal.querySelector('input[name="gls_delivery_option"]')?.focus({ preventScroll: true });
    });
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
  };

  const updateLockerState = (modal) => {
    const selected = selectedOption(modal);
    const needsLocker = Boolean(selected?.hasAttribute('data-gls-locker-option'));
    const lockerFields = modal?.querySelector('[data-gls-locker-fields]');
    const selectedPoint = modal?.querySelector('[data-gls-selected-point]');
    const mapButton = modal?.querySelector('[data-gls-map-open]');

    if (lockerFields) lockerFields.hidden = !needsLocker;
    if (selectedPoint) selectedPoint.hidden = !needsLocker || !modal?.dataset.glsPointId;
    if (mapButton) mapButton.hidden = !needsLocker || !modal?.dataset.glsPointId;
    clearError(modal);
  };

  const getDeliveryPointHash = (point) =>
    point?.hash || point?.parcelShopHash || point?.parcelshopHash || point?.parcelShopId || point?.id || '';

  const getDeliveryPointName = (point) =>
    point?.parcelShopName || point?.parcelshopName || point?.name || '';

  const getDeliveryPointAddressJson = (point) => {
    const contact = point?.contact || {};

    return JSON.stringify({
      country: contact.countryCode || point?.countryCode || point?.country || 'SI',
      address: contact.address || point?.address || '',
      city: contact.city || point?.city || '',
      zipCode: contact.postalCode || contact.zipCode || point?.postalCode || point?.zipCode || '',
    });
  };

  const getDeliveryPointType = (point) =>
    String(point?.type || point?.deliveryPointType || point?.DeliveryPointType || '').toLowerCase();

  const isValidLockerPoint = (point) => {
    const type = getDeliveryPointType(point);
    return !type || type === 'parcel-locker' || type === 'parcel-shop' || type === '2' || type === '1';
  };

  const formatDeliveryPoint = (point) => {
    if (!point) return '';
    const contact = point.contact || {};
    const id = getDeliveryPointHash(point);
    const name = getDeliveryPointName(point);
    const address = [
      contact.address || point.address,
      contact.postalCode || point.postalCode || point.zipCode,
      contact.city || point.city,
    ]
      .filter(Boolean)
      .join(', ');

    return `
      <strong>Izbrano: ${escapeHtml(name || 'GLS paketomat')}</strong>
      ${address ? `<span>${escapeHtml(address)}</span>` : ''}
      ${id ? `<small>ID: ${escapeHtml(id)}</small>` : ''}
    `;
  };

  const saveDeliveryPoint = (modal, point) => {
    if (!modal || !point) return;

    if (!isValidLockerPoint(point)) {
      showError(modal, 'Izberi paketomat, ne GLS depoja.');
      modal.dataset.glsPointId = '';
      modal.dataset.glsPointName = '';
      modal.dataset.glsPointAddress = '';
      modal.dataset.glsPointPayload = '';
      modal.dataset.glsParcelshopAddressJson = '';
      return;
    }

    modal.dataset.glsPointId = getDeliveryPointHash(point);
    modal.dataset.glsPointName = getDeliveryPointName(point);
    modal.dataset.glsPointAddress = [
      point.contact?.address || point.address,
      point.contact?.postalCode || point.postalCode || point.zipCode,
      point.contact?.city || point.city,
      point.contact?.countryCode || point.countryCode || point.country,
    ]
      .filter(Boolean)
      .join(', ');
    modal.dataset.glsPointPayload = JSON.stringify(point);
    modal.dataset.glsParcelshopAddressJson = getDeliveryPointAddressJson(point);

    const selectedPoint = modal.querySelector('[data-gls-selected-point]');
    if (selectedPoint) {
      selectedPoint.innerHTML = formatDeliveryPoint(point);
      selectedPoint.hidden = false;
    }
    modal.querySelector('[data-gls-map-open]')?.removeAttribute('hidden');
    clearError(modal);
    enableSubmit(modal);
  };

  const cartAttributeArray = (attributes = {}) =>
    Object.entries(attributes)
      .filter(([, value]) => value !== null && value !== undefined && String(value) !== '')
      .map(([key, value]) => ({ key, value: String(value) }));

  const lineAttributeArray = (properties = {}) =>
    Object.entries(properties || {})
      .filter(([, value]) => value !== null && value !== undefined && String(value) !== '')
      .map(([key, value]) => ({
        key,
        value: typeof value === 'string' ? value : JSON.stringify(value),
      }));

  const storefrontRequest = async (modal, query, variables) => {
    const domain = modal.dataset.spzdblStorefrontDomain;
    const version = modal.dataset.spzdblStorefrontApiVersion || '2026-04';
    const token = modal.dataset.spzdblStorefrontToken;

    if (!domain || !token) throw new Error('Missing Storefront API setup.');

    const response = await fetch(`https://${domain}/api/${version}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query, variables }),
    });

    const payload = await response.json().catch(() => ({}));

    if (!response.ok || payload.errors?.length) {
      throw new Error(payload.errors?.[0]?.message || 'Storefront API request failed.');
    }

    return payload.data;
  };

  const firstUserError = (payload) => payload?.userErrors?.[0]?.message || '';

  const firstWarning = (payload) => payload?.warnings?.[0]?.message || '';

  // Storefront API vidi samo izdelke, objavljene v njenem prodajnem kanalu (Headless). Vrstica
  // košarice, ki je kanal ne vidi, ob dotiku Storefront API tiho izpade iz košarice
  // (24. 9. 2026: pulover »ni panike« ni bil objavljen v Headless → blagajna brez puloverja).
  // Zato pred VSAKIM klicem preverimo, da kanal vidi vse variante; če ne, gre naravnost /checkout.
  const storefrontSeesAllLines = async (modal, cart) => {
    const ids = (cart?.items || []).map((item) => `gid://shopify/ProductVariant/${item.variant_id}`);
    if (!ids.length) return false;

    const data = await storefrontRequest(
      modal,
      `query SpzdblCartLinesVisible($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on ProductVariant {
            id
          }
        }
      }`,
      { ids }
    );

    const nodes = data?.nodes;
    if (!Array.isArray(nodes) || nodes.length !== ids.length) return false;

    return nodes.every((node) => Boolean(node?.id));
  };

  const fetchAjaxCart = async () => {
    const cartResponse = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    const cart = await cartResponse.json();

    if (!cartResponse.ok || !cart?.items?.length) throw new Error('Cart is empty.');

    return cart;
  };

  const normalizePickupHandle = (value) => {
    const handle = String(value || '').trim();
    const locationMatch = handle.match(/^gid:\/\/shopify\/Location\/(\d+)$/i);

    return locationMatch ? locationMatch[1] : handle;
  };

  const createPreferenceCheckoutUrl = async (modal, selected, needsLocker, glsPointId, glsPointName, glsParcelshopAddressJson, deliveryPreference) => {
    const cart = await fetchAjaxCart();

    const attributes = {
      ...(cart.attributes || {}),
      'SPZDBL GLS delivery option': selected.value,
      'SPZDBL GLS delivery code': selected.dataset.glsDeliveryCode || '',
      glsParcelShopHash: needsLocker ? glsPointId : '',
      glsParcelshopName: needsLocker ? glsPointName : '',
      glsParcelshopAddressJson: needsLocker ? glsParcelshopAddressJson : '',
      'SPZDBL GLS delivery point ID': '',
      'SPZDBL GLS delivery point name': '',
      'SPZDBL GLS delivery point address': '',
      'SPZDBL GLS delivery point data': '',
    };

    const lines = cart.items.map((item) => ({
      merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`,
      quantity: item.quantity,
      attributes: lineAttributeArray(item.properties),
    }));

    const createData = await storefrontRequest(
      modal,
      `mutation SpzdblCreatePreferenceCart($input: CartInput!) {
        cartCreate(input: $input) {
          cart {
            id
            checkoutUrl
            totalQuantity
          }
          userErrors {
            field
            message
          }
          warnings {
            code
            message
          }
        }
      }`,
      {
        input: {
          lines,
          attributes: cartAttributeArray(attributes),
          note: cart.note || undefined,
        },
      }
    );

    const createPayload = createData?.cartCreate;
    const createError = firstUserError(createPayload) || firstWarning(createPayload);
    if (createError || !createPayload?.cart?.id) throw new Error(createError || 'Cart creation failed.');

    // Kopija mora nositi vse kose; drugače je Storefront kaj izpustil in gre naprej izvirna košarica.
    if (createPayload.cart.totalQuantity !== cart.item_count) {
      throw new Error(`Cart copy incomplete: ${createPayload.cart.totalQuantity} of ${cart.item_count} items.`);
    }

    const preferenceData = await storefrontRequest(
      modal,
      `mutation SpzdblSetDeliveryPreference($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
          cart {
            id
            checkoutUrl
          }
          userErrors {
            field
            message
          }
        }
      }`,
      {
        cartId: createPayload.cart.id,
        buyerIdentity: {
          countryCode: 'SI',
          preferences: {
            delivery: deliveryPreference,
          },
        },
      }
    );

    const preferencePayload = preferenceData?.cartBuyerIdentityUpdate;
    const preferenceError = firstUserError(preferencePayload);
    if (preferenceError) throw new Error(preferenceError);

    return preferencePayload?.cart?.checkoutUrl || createPayload.cart.checkoutUrl;
  };

  const createPickupCheckoutUrl = async (modal, selected, needsLocker, glsPointId, glsPointName, glsParcelshopAddressJson) => {
    const pickupHandle = normalizePickupHandle(modal.dataset.spzdblPickupHandle);
    if (!pickupHandle) throw new Error('Missing pickup handle.');

    return createPreferenceCheckoutUrl(modal, selected, needsLocker, glsPointId, glsPointName, glsParcelshopAddressJson, {
      deliveryMethod: ['PICK_UP'],
      pickupHandle: [pickupHandle],
    });
  };

  const createShippingCheckoutUrl = async (modal, selected, needsLocker, glsPointId, glsPointName, glsParcelshopAddressJson) =>
    createPreferenceCheckoutUrl(modal, selected, needsLocker, glsPointId, glsPointName, glsParcelshopAddressJson, {
      deliveryMethod: ['SHIPPING'],
    });

  const deliveryPreferenceForSelection = (modal, selected) => {
    if (selected?.dataset.glsDeliveryCode === 'local_pickup') {
      const pickupHandle = normalizePickupHandle(modal.dataset.spzdblPickupHandle);
      if (!pickupHandle) return null;

      return {
        deliveryMethod: ['PICK_UP'],
        pickupHandle: [pickupHandle],
      };
    }

    return { deliveryMethod: ['SHIPPING'] };
  };

  const applyPreferenceToCurrentCart = async (modal, selected) => {
    const preference = deliveryPreferenceForSelection(modal, selected);
    if (!preference) throw new Error('Missing pickup handle.');

    const cartResponse = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });
    const cart = await cartResponse.json();
    const token = String(cart?.token || '');

    if (!cartResponse.ok || !token.includes('?key=')) {
      throw new Error('Cart token is not usable with the Storefront API.');
    }

    const data = await storefrontRequest(
      modal,
      `mutation SpzdblSetCartPreference($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
          cart {
            id
          }
          userErrors {
            field
            message
          }
        }
      }`,
      {
        cartId: `gid://shopify/Cart/${token}`,
        buyerIdentity: {
          countryCode: 'SI',
          preferences: {
            delivery: preference,
          },
        },
      }
    );

    const payload = data?.cartBuyerIdentityUpdate;
    const error = firstUserError(payload);
    if (error || !payload?.cart?.id) throw new Error(error || 'Cart preference update failed.');
  };

  const shouldUseStorefrontPickup = (modal, selected) =>
    selected?.dataset.glsDeliveryCode === 'local_pickup' &&
    modal?.dataset.spzdblStorefrontPickupEnabled === 'true' &&
    modal?.dataset.spzdblStorefrontToken &&
    modal?.dataset.spzdblPickupHandle;

  const shouldUseStorefrontShipping = (modal, selected) =>
    selected?.dataset.glsDeliveryCode !== 'local_pickup' &&
    modal?.dataset.spzdblStorefrontPickupEnabled === 'true' &&
    modal?.dataset.spzdblStorefrontToken;

  const openGlsMap = async (modal) => {
    const map = modal?.querySelector('[data-gls-dpm-dialog]');
    if (!map) return;

    ensureGlsWidgetScript();

    if (typeof map.showModal !== 'function' && window.customElements?.whenDefined) {
      try {
        await Promise.race([
          window.customElements.whenDefined('gls-dpm-dialog'),
          new Promise((resolve) => setTimeout(resolve, 2500)),
        ]);
      } catch (error) {
        // The GLS widget handles its own loading; this keeps the cart UI responsive.
      }
    }

    if (typeof map.showModal !== 'function') {
      showError(modal, 'GLS zemljevid se še nalaga. Poskusi še enkrat čez trenutek.');
      return;
    }

    if (!map.dataset.listenerReady) {
      map.addEventListener('change', (event) => {
        saveDeliveryPoint(modal, event.detail);
      });
      map.dataset.listenerReady = 'true';
    }

    map.showModal();
  };

  window.spzdblOpenGlsDeliveryChooser = (opener) => {
    openModal(getModalForOpener(opener));
  };

  if (window.__spzdblGlsDeliveryModalReady) return;
  window.__spzdblGlsDeliveryModalReady = true;

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const opener = target.closest('[data-gls-delivery-open]');
    if (opener) {
      event.preventDefault();
      openModal(getModalForOpener(opener));
      return;
    }

    const codOffCloser = target.closest('[data-gls-cod-off-close]') || (target.matches('[data-gls-cod-off-notice]') ? target : null);
    if (codOffCloser) {
      hideCodOffNotice(codOffCloser.closest('[data-gls-cod-off-notice]'));
      return;
    }

    const closer = target.closest('[data-gls-delivery-close]');
    if (closer) {
      closeModal(closer.closest('[data-gls-delivery-modal]'));
      return;
    }

    const mapOpener = target.closest('[data-gls-map-open]');
    if (mapOpener) {
      openGlsMap(mapOpener.closest('[data-gls-delivery-modal]'));
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const modal = target?.closest('[data-gls-delivery-modal]');
    if (!modal) return;

    if (target?.matches?.('input[name="gls_delivery_option"][data-gls-cod-off]')) {
      target.checked = false;
      const previous = lastValidOption.get(modal);
      if (previous?.isConnected) previous.checked = true;
      updateLockerState(modal);
      showCodOffNotice(modal);
      return;
    }

    if (target?.matches?.('input[name="gls_delivery_option"]')) lastValidOption.set(modal, target);

    updateLockerState(modal);
    enableSubmit(modal);

    if (target?.matches?.('input[name="gls_delivery_option"][data-gls-locker-option]')) {
      openGlsMap(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openNotice = openCodOffNotice();
    if (openNotice) {
      event.preventDefault();
      hideCodOffNotice(openNotice);
      return;
    }
    const modal = document.querySelector('[data-gls-delivery-modal]:not([hidden])');
    if (modal) closeModal(modal);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof Element ? event.target.closest('[data-gls-delivery-form]') : null;
    if (!form) return;

    event.preventDefault();

    const modal = form.closest('[data-gls-delivery-modal]');
    clearError(modal);

    const selected = selectedOption(modal);
    if (!selected) {
      showError(modal, 'Najprej izberi način dostave.');
      return;
    }

    if (selected.hasAttribute('data-gls-cod-off')) {
      selected.checked = false;
      showCodOffNotice(modal);
      return;
    }

    const needsLocker = selected.hasAttribute('data-gls-locker-option');
    const glsPointId = modal.dataset.glsPointId || '';
    const glsPointName = modal.dataset.glsPointName || '';
    const glsParcelshopAddressJson = modal.dataset.glsParcelshopAddressJson || '';

    if (needsLocker && !glsPointId) {
      showError(modal, 'Najprej izberi paketomat ali prevzemno točko na GLS zemljevidu.');
      modal.querySelector('[data-gls-map-open]')?.focus();
      return;
    }

    const submitButton = modal.querySelector('[data-gls-delivery-submit]');
    submitButton?.setAttribute('disabled', 'disabled');

      try {
        const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'SPZDBL GLS delivery option': selected.value,
            'SPZDBL GLS delivery code': selected.dataset.glsDeliveryCode || '',
            glsParcelShopHash: needsLocker ? glsPointId : '',
            glsParcelshopName: needsLocker ? glsPointName : '',
            glsParcelshopAddressJson: needsLocker ? glsParcelshopAddressJson : '',
            'SPZDBL GLS delivery point ID': '',
            'SPZDBL GLS delivery point name': '',
            'SPZDBL GLS delivery point address': '',
            'SPZDBL GLS delivery point data': '',
          },
        }),
      });

        if (!response.ok) throw new Error('Cart update failed');

        if (
          modal.dataset.spzdblStorefrontPickupEnabled === 'true' &&
          modal.dataset.spzdblStorefrontToken
        ) {
          // Varovalo: če Storefront kanal ne vidi vseh kosov, se ga ne dotaknemo — atributi dostave
          // so že shranjeni, Shopify Functions jih berejo tudi na navadni blagajni.
          let allVisible = false;
          try {
            allVisible = await storefrontSeesAllLines(modal, await fetchAjaxCart());
          } catch (visibilityError) {
            console.warn('[SPZDBL] Storefront visibility check failed, using plain checkout.', visibilityError);
          }

          if (!allVisible) {
            console.warn('[SPZDBL] Storefront channel does not see every cart line, using plain checkout.');
            window.location.href = '/checkout';
            return;
          }

          try {
            await applyPreferenceToCurrentCart(modal, selected);
            window.location.href = '/checkout';
            return;
          } catch (sameCartError) {
            console.warn('[SPZDBL] Same-cart preference failed, falling back to cart copy.', sameCartError);
          }
        }

        if (shouldUseStorefrontPickup(modal, selected)) {
          try {
            const checkoutUrl = await createPickupCheckoutUrl(
              modal,
              selected,
              needsLocker,
              glsPointId,
              glsPointName,
              glsParcelshopAddressJson
            );

            if (checkoutUrl) {
              window.location.href = checkoutUrl;
              return;
            }
          } catch (storefrontError) {
            console.warn('[SPZDBL] Storefront pickup checkout failed, falling back to /checkout.', storefrontError);
            showError(
              modal,
              modal.dataset.spzdblPickupError ||
                'Prevzema trenutno ni bilo mogoče pripraviti. Nadaljujem na običajno blagajno.'
            );
            await new Promise((resolve) => setTimeout(resolve, 1200));
          }
        } else if (shouldUseStorefrontShipping(modal, selected)) {
          try {
            const checkoutUrl = await createShippingCheckoutUrl(
              modal,
              selected,
              needsLocker,
              glsPointId,
              glsPointName,
              glsParcelshopAddressJson
            );

            if (checkoutUrl) {
              window.location.href = checkoutUrl;
              return;
            }
          } catch (storefrontError) {
            console.warn('[SPZDBL] Storefront shipping checkout failed, falling back to /checkout.', storefrontError);
          }
        }

        window.location.href = '/checkout';
      } catch (error) {
        showError(modal, 'Izbire dostave ni bilo mogoče shraniti. Poskusi še enkrat.');
      submitButton?.removeAttribute('disabled');
    }
  });
})();
